import React from "react";
import CommonGrid from "./CommonGrid";
import { ColumnType } from "../../../../components/Grid/constants";
import { Order } from "../../../../components/Grid/dataProvider";
import useAuditEnums from "../audit/useAuditEnums";
import { entityLabel, entityTypeItemsFor, actionsFor } from "../audit/entityLabels";

export default (props) => {
  const { auth, dispatch, showOwner = true, showEntity = showOwner, allowedEntityTypes, allowedActions } = props;
  const { actions, roles } = useAuditEnums(auth, dispatch);
  if (actions.length === 0 || roles.length === 0) {
    return <div style={{ padding: 16 }}>Načítám…</div>;
  }
  const colCount = 4 + (showOwner ? 1 : 0) + (showEntity ? 1 : 0);
  const w = `${100 / colCount}%`;
  const columns = [
    {
      field: "authorName",
      label: "Uživatel",
      type: ColumnType.TEXT,
      width: w,
      mapper: (val, row) => val || (row && row.author) || "",
    },
    {
      field: "authorRole",
      label: "Role",
      type: ColumnType.TEXT,
      width: w,
      mapper: (val) => roles.find((r) => r.id === val)?.label || val,
      filterItems: roles,
    },
    {
      field: "timestamp",
      label: "Datum",
      type: ColumnType.DATETIME,
      width: w,
    },
    {
      field: "action",
      label: "Akce",
      type: ColumnType.TEXT,
      width: w,
      mapper: (val) => actions.find((a) => a.id === val)?.label || val,
      filterItems: actionsFor(allowedActions, actions),
    },
    ...(showOwner
      ? [{
          field: "displayEntityType",
          label: "Typ",
          type: ColumnType.TEXT,
          width: w,
          mapper: (val, row) => entityLabel((row && row.entityType) || val),
          filterItems: entityTypeItemsFor(allowedEntityTypes),
        }]
      : []),
    ...(showEntity
      ? [{
          field: "entityLabel",
          label: "Entita",
          type: ColumnType.TEXT,
          width: w,
        }]
      : []),
  ];

  const pageSizeItems = [
    { id: 10, label: "10" },
    { id: 20, label: "20" },
    { id: 50, label: "50" },
    { id: 100, label: "100" },
  ];

  return (
    <CommonGrid
      {...props}
      columns={columns}
      pageSizeItems={pageSizeItems}
      filters={[]}
      sort="timestamp"
      order={Order.DESC}
    />
  );
};
